import React from 'react';
import PropTypes from 'prop-types';

import Property from './Property';
import ApiExample from './ApiExample';

// Presentational Component
const Response = ({ response }) => {

	const isFileStream = response.metadata && response.metadata.isFileStream;

	return (
		<div className="response">
			<div>
				<div className="prop-heading">
					<h4>Response</h4>
					{!isFileStream && <ApiExample apiItem={response} />}
				</div>

				<div className="properties">
					{isFileStream ?
						<Property field={{ name: 'File', summary: 'A a content stream for a file such as a .zip or .csv', type: 'Stream' }} />
						:
						response.fields.map(field =>
							<Property key={field.name} field={field} />)
					}
				</div>
				<br />
			</div>
		</div>
	);
};

Response.propTypes = {
	response: PropTypes.object.isRequired,
};

export default Response;


// WEBPACK FOOTER //
// ./src/components/api/Response.js